const router = [
  {
    path: "/intro",
    meta: {
      title: "公司介绍"
      // keepAlive: true
    },
    component: resolve => require(["../views/home/intro"], resolve)
  },
  {
    path: "/service",
    meta: {
      title: "仓储中心"
      // keepAlive: true
    },
    component: resolve => require(["../views/service/index"], resolve)
  },
  {
    path: "/service/detail",
    meta: {
      title: "仓储中心详情"
      // keepAlive: true
    },
    component: resolve => require(["../views/service/detail"], resolve)
  },
  {
    path: "/newsNew",
    meta: {
      title: "新闻中心"
      // keepAlive: true
    },
    component: resolve => require(["../views/newsNew/index"], resolve)
  },
  {
    path: "/newsNew/detail",
    meta: {
      title: "新闻中心详情"
      // keepAlive: true
    },
    component: resolve => require(["../views/newsNew/detail"], resolve)
  },
  {
    path: "/rules",
    meta: {
      title: "规则中心"
      // keepAlive: true
    },
    component: resolve => require(["../views/rules/index"], resolve)
  },
  {
    path: "/contactUs",
    meta: {
      title: "联系我们"
      // keepAlive: true
    },
    component: resolve => require(["../views/contactUs/index"], resolve)
  },
  {
    path: "/tradeCenter",
    meta: {
      title: "交易中心"
      // keepAlive: true
    },
    component: resolve => require(["../views/tradeCenter/index"], resolve)
  },
  {
    path: "/tradeCenter/list",
    meta: {
      title: "交易中心"
      // keepAlive: true
    },
    component: resolve => require(["../views/tradeCenter/list"], resolve)
  },
  {
    path: "/delivery",
    meta: {
      title: "交割中心"
      // keepAlive: true
    },
    component: resolve => require(["../views/delivery/index"], resolve)
  },
  {
    path: "/delivery/detail",
    meta: {
      title: "交割中心"
      // keepAlive: true
    },
    component: resolve => require(["../views/delivery/detail"], resolve)
  },
  {
    path: "/agreement/agreement",
    meta: {
      title: "隐私协议"
      // keepAlive: true
    },
    component: resolve => require(["../views/agreement/agreement"], resolve)
  }
];

export default router;



// WEBPACK FOOTER //
// ./src/router/home.js